import React from "react";
var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { jsx as _jsx } from "react/jsx-runtime";
export var Reset = function Reset() {
  return /*#__PURE__*/_jsx("div", {
    className: cx(baseReset, customReset)
  });
};
var baseReset = "bg0f7jk";
var customReset = "c1n8qu3a";

require("../../../apps/tv/.linaria-cache/packages/@webtv/css-reset/Reset.linaria.module.css");